<template>
  <v-container fill-height style="max-width: 1200px;">
    <v-layout row wrap align-center justify-center>
      <v-flex xs12>
        <v-form ref="form" v-model="valid">
          <v-card class="elevation-5">
            <v-layout row wrap align-center>
              <v-toolbar dark color="primary" class="mb-5 py-3 elevation-0">
                <h2 class="toolbar-title">NEW STUDENT REGISTRATION</h2>
              </v-toolbar>
            </v-layout>

            <student-information></student-information>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar color="warning" class="elevation-0">
                  <v-toolbar-title class="headline font-weight-bold">Parent Information</v-toolbar-title>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <parent-information title="Enrolling Parent" order="1"></parent-information>
                <parent-information title="Parent" order="2"></parent-information>
                <parent-information title="Parent" order="3"></parent-information>
                <parent-information title="Parent" order="4"></parent-information>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar color="warning" class="elevation-0">
                  <v-toolbar-title class="headline font-weight-bold">Emergency Contact</v-toolbar-title>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <emergency-contact order="1"></emergency-contact>
                <emergency-contact order="2"></emergency-contact>
                <emergency-contact order="3"></emergency-contact>
                <medical-contact-preferences></medical-contact-preferences>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" color="warning" class="elevation-0">
                  <h2 id="headline" class="mt-3 headline font-weight-bold">Student Health Conditions</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <health-conditions></health-conditions>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" extended color="warning" class="elevation-0">
                  <h2
                    id="headline"
                    class="mt-3 headline font-weight-bold"
                  >Elementary Student Registration</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <form-part-b></form-part-b>
                <br>
                <h2>SIBLING LIST:</h2>
                <p>Please list up to 5 brothers and sisters of school age and younger (oldest first).</p>
                <sibling order="1"></sibling>
                <sibling order="2"></sibling>
                <sibling order="3"></sibling>
                <sibling order="4"></sibling>
                <sibling order="5"></sibling>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" extended color="warning" class="elevation-0">
                  <h2
                    id="headline"
                    class="mt-3 headline font-weight-bold"
                  >Elementary Student Registration Form C</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <part-c-info></part-c-info>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" extended color="warning" class="elevation-0">
                  <h2
                    id="headline"
                    class="mt-3 headline font-weight-bold"
                  >Student Referral Questionnaire</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <student-referral-questionnaire></student-referral-questionnaire>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" extended color="warning" class="elevation-0">
                  <h2
                    id="headline"
                    class="mt-3 headline font-weight-bold"
                  >Rights of Homeless Students</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <rights-of-homeless-students></rights-of-homeless-students>
              </v-card-text>
            </v-card>

            <v-card class="elevation-0">
              <v-card-title>
                <v-toolbar id="toolbar2" extended color="warning" class="elevation-0">
                  <h2
                    id="headline"
                    class="mt-3 headline font-weight-bold"
                  >Arizona Residency Documentation</h2>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <az-residency-docs></az-residency-docs>
              </v-card-text>
            </v-card>
            <v-card-actions class="px-5 pb-3" style="flex-wrap: wrap;">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="submit" :loading="loading">Register</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import throttle from "lodash.throttle";
import StudentInformation from "./StudentInformation";
import ParentInformation from "./ParentInformation";
import EmergencyContact from "./EmergencyContact";
import MedicalContactPreferences from "./MedicalContactPreferences";
import HealthConditions from "./HealthConditions";
import FormPartB from "./FormPartB";
import Sibling from "./Sibling";
import PartCInfo from "./PartCInfo";
import StudentReferralQuestionnaire from "./StudentReferralQuestionnaire";
import AzResidencyDocs from "./AzResidencyDocs";
import RightsOfHomelessStudents from "./RightsOfHomelessStudents";

export default {
  components: {
    StudentInformation,
    ParentInformation,
    EmergencyContact,
    MedicalContactPreferences,
    HealthConditions,
    FormPartB,
    Sibling,
    PartCInfo,
    StudentReferralQuestionnaire,
    AzResidencyDocs,
    RightsOfHomelessStudents
  },
  data() {
    return {
      valid: false,
      success: false,
      loading: false
    };
  },
  computed: mapState({
    student: state => state.registration.student,
    parent_1: state => state.registration.parents.parent_1,
    parent_2: state => state.registration.parents.parent_2,
    parent_3: state => state.registration.parents.parent_3,
    parent_4: state => state.registration.parents.parent_4,
    contact_1: state => state.registration.emergencyContacts.contact_1,
    contact_2: state => state.registration.emergencyContacts.contact_2,
    contact_3: state => state.registration.emergencyContacts.contact_3,
    physician: state => state.registration.emergencyContacts.physician,
    hospital_preference: state =>
      state.registration.emergencyContacts.hospital_preference,
    student_health_conditions: state => state.registration.healthConditions,
    siblings: state => state.registration.siblings,
    partCInfo: state => state.registration.partCInfo,
    studentReferralQuestionnaire: state =>
      state.registration.studentReferralQuestionnaire,
    azResidencyDocs: state => state.registration.azResidencyDocs,
    rightsOfHomelessStudents: state =>
      state.registration.rightsOfHomelessStudents
  }),
  methods: {
    submit: throttle(function() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.$store.commit("clearErrors");
        this.$validator.validateAll().then(result => {
          if (result) {
            let information = this.generateRequestObject();

            // timer is for UX, so user knows button was clicked and form was submitted
            setTimeout(() => {
              this.$store
                .dispatch("registration/registerStudent", information)
                .then(() => {
                  this.success = true;
                  this.loading = false;
                  this.$refs.form.reset(); // this creates a bug that prevents the user from submitting
                  alert("Registration successful\nThanks for signing up.\nYou may now login to add your children and start enrolling in classes.");
                  this.$router.push({ name: "Login" });
                  this.$router.go(0); // this is the workaround to the bug caused by the reset
                })
                .catch(errors => {
                  this.loading = false;
                  this.$store.commit("setValidationErrors", errors);
                  let errorsToReport = new Array();
                  for (const [key, value] of Object.entries(
                    this.$store.state.errorModule.validation.messages
                  )) {
                    errorsToReport.push(value);
                  }
                  alert(
                    "Registration NOT successful\n" +
                      errorsToReport
                        .toString()
                        .split(",")
                        .join("\n")
                  );
                });
            }, 500);
          } else {
            this.loading = false;
          }
        });
      } else {
        this.loading = false;
        alert("Registration Failed\nPlease complete all the fields in red.");
      }
    }, 1000),
    generateRequestObject() {
      return {
        student: this.student,
        parent_1: this.parent_1,
        parent_2: this.parent_2,
        parent_3: this.parent_3,
        parent_4: this.parent_4,
        contact_1: this.contact_1,
        contact_2: this.contact_2,
        contact_3: this.contact_3,
        physician: this.physician,
        hospital_preference: this.hospital_preference,
        student_health_conditions: this.student_health_conditions,
        siblings: this.siblings,
        partCInfo: this.partCInfo,
        studentReferralQuestionnaire: this.studentReferralQuestionnaire,
        azResidencyDocs: this.azResidencyDocs,
        rightsOfHomelessStudents: this.rightsOfHomelessStudents
      };
    }
  }
};
</script>

